import type { PropsWithChildren } from 'react';
import { GovFlex } from '@gov-design-system-ce/react';

export const SearchGridHeader = ({ children }: PropsWithChildren) => (
	<GovFlex
		justifyContent="space-between"
		alignItems="center"
		gap="m"
		className="w-full">
		{children}
	</GovFlex>
);
